export default "__VITE_ASSET__DkpA5U$a__"